import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';

import { Badge, Typography } from '@sravni/react-design-system';
import { Image } from '@sravni/react-image';

import styles from './EbsInformer.module.scss';

export function EbsInformer({
  step,
  title,
  image,
  subtitle,
  imageStyles,
}: {
  title: string | ReactNode;
  step: number;
  image?: string;
  subtitle?: ReactNode;
  imageStyles?: { height: number; width: number; margin?: string; padding?: string };
}) {
  return (
    <div className={classNames(styles.container, { [styles.full]: !!image })}>
      <div className={styles.content}>
        <Badge text={`Шаг ${step}`} variant="primary" />
        <Typography.Text>{title}</Typography.Text>
        {subtitle && subtitle}
      </div>

      {image && (
        <div className={styles.imageContainer}>
          <Image width={112} height={111} {...imageStyles} style={imageStyles} src={image} />
        </div>
      )}
    </div>
  );
}
